import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "../assets/vyapakprints-logo.png";

const Navbar = ({ title = "Dashboard" }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/");
    }
  };

  const goHome = () => {
    navigate("/");
  };

  const isHomePage = location.pathname === "/";

  return (
    <nav className="sticky top-0 z-50 bg-gray-800 text-white shadow-md">
      <div className="px-4 sm:px-6">
        <div className="flex min-h-[72px] flex-wrap items-center justify-between gap-3">
          {/* Left */}
          <div className="flex items-center gap-3 min-w-0">
            <button
              onClick={goHome}
              className="flex items-center rounded-xl px-2 py-1 transition hover:bg-gray-700"
            >
              <img
                src={logo}
                alt="Vyapakprint"
                className="h-8 md:h-10 bg-white object-contain rounded"
              />
            </button>

            <div className="hidden md:block h-8 w-px bg-gray-600" />

            <div className="hidden md:block min-w-0">
              <h1 className="truncate text-lg font-semibold text-white">
                {title}
              </h1>
            </div>
          </div>

          {/* Right */}
          <div className="flex flex-wrap items-center justify-end gap-2">
            <button
              onClick={handleBack}
              className="inline-flex items-center gap-2 rounded-lg border border-gray-500 bg-gray-700 px-4 py-2 text-sm font-medium text-white transition hover:bg-gray-600"
            >
              <svg
                className="h-4 w-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 19l-7-7 7-7"
                />
              </svg>
              Back
            </button>

            {!isHomePage && (
              <button
                onClick={goHome}
                className="inline-flex items-center gap-2 rounded-lg border border-blue-400 bg-blue-500 px-4 py-2 text-sm font-medium text-white transition hover:bg-blue-600"
              >
                <svg
                  className="h-4 w-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 10.5l9-7 9 7M5 9.5V20h14V9.5"
                  />
                </svg>
                Home
              </button>
            )}

            <button
              onClick={handleLogout}
              className="inline-flex items-center gap-2 rounded-lg bg-red-500 px-4 py-2 text-sm font-medium text-white transition hover:bg-red-600"
            >
              <svg
                className="h-4 w-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M17 16l4-4m0 0l-4-4m4 4H9m4 8H7a2 2 0 01-2-2V6a2 2 0 012-2h6"
                />
              </svg>
              Logout
            </button>
          </div>
        </div>

        {/* Mobile title */}
        <div className="pb-3 md:hidden">
          <h1 className="text-sm font-semibold text-white truncate">{title}</h1>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
